import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ShipmentPackageApi  = createApi({
  reducerPath: "ShipmentPackageApi",
  baseQuery,
  tagTypes: ["ShipmentPackage"],
  endpoints: (builder) => ({
    // GET by exporterMasterId
    getPackageDetailsByMasterId: builder.query({
      query: (exporterMasterId) => `shipment/packingDetails/${exporterMasterId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["ShipmentPackage"],
    }),

    // GET by exporterMasterId + packingDetailsId
    getPackageDetailsById: builder.query({
      query: ({ exporterMasterId, packingDetailsId }) =>
        `shipment/packingDetails/${exporterMasterId}/${packingDetailsId}`,
      transformResponse: (response) => response?.data ?? {},
      providesTags: ["ShipmentPackage"],
    }),

    // CREATE
    createPackageDetails: builder.mutation({
      query: ({ exporterMasterId, packingDetails }) => ({
        url: `shipment/packingDetails/${exporterMasterId}`,
        method: "POST",
        body: { packingDetails },
      }),
      invalidatesTags: ["ShipmentPackage"],
    }),

    // UPDATE
    updatePackageDetails: builder.mutation({
      query: ({ exporterMasterId, packingDetailsId, packingDetails }) => ({
        url: `shipment/packingDetails/${exporterMasterId}/${packingDetailsId}`,
        method: "PUT",
        body: { packingDetails },
      }),
      invalidatesTags: ["ShipmentPackage"],
    }),

    // DELETE
    deletePackageDetails: builder.mutation({
      query: ({ packingDetailsId }) => ({
        url: `shipment/packingDetails/${packingDetailsId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ShipmentPackage"],
    }),
  }),
});

export const {
  useGetPackageDetailsByMasterIdQuery,
  useyGetPackageDetailsByIdQuery,
  useCreatePackageDetailsMutation,
  useUpdatePackageDetailsMutation,
  useDeletePackageDetailsMutation,
} = ShipmentPackageApi;
